<template>
  <div class="MallDepartment" style="text-align:center;">
      商城部-暂无数据
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>